import { useState } from "react";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { isFoundationUnlocked } from "utils/foundationUnlock"; // adjust path as needed

import { dashboardAssets } from "../../imagesData/ImagesData";
import useFetchImageUrls from "../../ConstantUseFetchImageUrls";

const getStatus = (completed, total) => {
  if (completed === total && total > 0) return "completed";
  if (completed === 0) return "pending";
  return "progress";
};

function Dashboardpointssection() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userLevelDes = activeAccount.idTokenClaims?.jobFamilyDescription;

  const [openId, setOpenId] = useState("Foundation");

  const { coursesByHub } = useSelector((state) => state.courseDetails);
  const userData = useSelector((state) => state.userDetails.userData?.[0]);

  const isEmpty = (value) =>
    value === null || value === undefined || value === "" || value === "NULL";
  const userLevel = isEmpty(userLevelDes) ? userData?.level : userLevelDes;

  const { foundationStatus, categoryPoints } = useSelector(
    (state) => state.learnersReport,
  );

  const totalPoints = categoryPoints?.totalPoints || 0;

  // Determine if Foundation hub is unlocked using the util
  const isFoundationCompleted = isFoundationUnlocked({
    coursesByHub,
    userData,
    userLevel,
  });

  const toggle = (id, locked) => {
    if (!locked) {
      setOpenId(openId === id ? null : id);
    }
  };

  const query = `params=${encodeURIComponent(JSON.stringify(dashboardAssets))}`;
  const { imageUrls, error } = useFetchImageUrls(query);

  const urls = imageUrls?.imageUrl || {};

  if (error) return <div>Error loading assets.</div>;
  if (!imageUrls || Object.keys(imageUrls).length === 0) return null;

  const getStatusIcon = (status) => {
    switch (status) {
      case "completed":
        // return "/Assets/Dashboard/module-complete-icon.png";
        return urls["moduleCompleteicon"] || "";
      case "progress":
        // return "/Assets/Dashboard/module-progress-icon.png";
        return urls["moduleProgressicon"] || "";
      case "pending":
        // return "/Assets/Dashboard/module-pending-icon.png";
        return urls["modulePendingicon"] || "";
      default:
        return "";
    }
  };

  const getHubIcon = (hubName, locked, isOpen) => {
    const map = {
      Foundation: "Foundation",
      "GenAI and Agentic AI Hub": "AI",
      "Sales & Solutioning Hub": "Sales",
      "Product Hub": "Product",
      "Delivery Modernisation Hub": "Delivery",
      "Future of Experience Hub": "Future",
      "Digital Customer Hub": "DigitalCustomer",
    };

    // const key = map[hubName];
    // if (!key) return "";

    // if (locked) {
    //   return `/Assets/LearningHubs/TabIcons/${key}-inactive.png`;
    // }

    // return isOpen
    //   ? `/Assets/LearningHubs/TabIcons/${key}.png`
    //   : `/Assets/LearningHubs/TabIcons/${key}-inactive.png`;

    const key = map[hubName];
    if (!key) return "";

    if (locked) {
      return urls[`${key}Inactive`];
    }

    return isOpen ? urls[`${key}Active`] : urls[`${key}Inactive`];
  };

  const HUB_ORDER = [
    "Foundation",
    "GenAI and Agentic AI Hub",
    "Sales & Solutioning Hub",
    "Delivery Modernisation Hub",
    "Future of Experience Hub",
    "Product Hub",
    "Digital Customer Hub",
  ];

  const sortedHubs = [...(coursesByHub || [])].sort((a, b) => {
    return HUB_ORDER.indexOf(a.hubName) - HUB_ORDER.indexOf(b.hubName);
  });

  return (
    <div className="dashboard-points-wrap">
      <div className="dashboard-points-row row1">
        <h3 className="h3-head">Points Earned History</h3>
        <p>{totalPoints} earned</p>
      </div>

      <div className="dashboard-points-row row2">
        <div className="accordion-container">
          {sortedHubs?.map((hub) => {
            const hubName = hub.hubName;

            // Lock logic using utils
            const locked = hubName !== "Foundation" && !isFoundationCompleted;

            const isOpen = openId === hubName;
            const hubIcon = getHubIcon(hub.hubName, locked, isOpen);

            const getCoursesByCategory = (category) =>
              hub?.courses?.filter((course) => course?.category === category) ||
              [];

            return (
              <div key={hubName} className="accordion-item" data-aos="zoom-in">
                <div
                  className={`accordion-header ${locked ? "locked" : ""}`}
                  onClick={() => toggle(hubName, locked)}
                >
                  <div className="hub-title">
                    <img
                      // src={process.env.PUBLIC_URL + hubIcon}
                      src={hubIcon}
                      alt={hubName}
                      className="hub-icon"
                    />
                    <span>
                      {hubName === "Foundation" ? "Core Hub" : hubName}
                    </span>
                  </div>

                  {locked && (
                    <img
                      // src={
                      //   process.env.PUBLIC_URL +
                      //   "/Assets/Dashboard/badges-lock-key.png"
                      // }
                      src={urls["badgesLockkey"]}
                      alt="locked"
                      className="badges-lock-key"
                    />
                  )}
                </div>

                {isOpen && hub.categoryPoints && (
                  <div className="accordion-content timeline">
                    <div className="timeline-line" />

                    {Object.entries(hub.categoryPoints)
                      .filter(([category]) => {
                        if (hubName === "GenAI and Agentic AI Hub") {
                          return ![
                            "Industry",
                            "Technology",
                            "Digital Customer",
                          ].includes(category);
                        }
                        return true;
                      })
                      .map(([category, data], index) => {
                        const status = getStatus(
                          data.completedCourses,
                          data.totalCourses,
                        );

                        const categoryCourses = getCoursesByCategory(category);
                        const earnedPoints = categoryCourses.reduce(
                          (sum, course) => {
                            const isCompleted = Boolean(course.completionDate);
                            return (
                              sum + (isCompleted ? course.coursePoints || 0 : 0)
                            );
                          },
                          0,
                        );

                        return (
                          <div key={index} className="module-row timeline-row">
                            <span className={`timeline-icon ${status}`}>
                              <img
                                // src={
                                //   process.env.PUBLIC_URL + getStatusIcon(status)
                                // }
                                src={getStatusIcon(status)}
                                alt={status}
                                className="module-icon"
                              />
                            </span>

                            <div className="module-left">
                              <span>{category}</span>
                              <p>
                                {data.completedCourses}/{data.totalCourses}{" "}
                                trainings completed
                              </p>
                            </div>

                            <div className="points">
                              <img
                                // src={
                                //   process.env.PUBLIC_URL +
                                //   "/Assets/Dashboard/points-icon.png"
                                // }
                                src={urls["pointsIcon"]}
                                alt="points"
                                className="points-icon"
                              />
                              {earnedPoints} Points Earned
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Dashboardpointssection;
